<div class="dropzone" appFileDnD (fileDropped)="onFileDropped($event)">
  <input
    type="file"
    [multiple]="multiple"
    (change)="fileBrowseHandler($event.target)"
    accept="image/png, image/jpg, image/jpeg, image/webp"
  />
  <img src="assets/icons/ic-upload-file.svg" alt="Upload Icon" />
  <div class="mt-3">
    <h3>Drop {{ multiple ? 'files' : 'file' }} here</h3>
    <h3>or</h3>
    <label for="fileDropRef">Browse for file</label>
  </div>
</div>
